import React from 'react';

const TaraBadge = ({ variant = 'default', size = 'md', children, className = '' }) => {
  const variants = {
    calm: 'bg-green-100 text-green-800 border-green-200',
    watchful: 'bg-amber-100 text-amber-800 border-amber-200',
    intense: 'bg-red-100 text-red-800 border-red-200',
    transforming: 'bg-purple-100 text-purple-800 border-purple-200',
    default: 'bg-stone-100 text-stone-800 border-stone-200',
  }
  
  const sizes = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-3 py-1 text-sm',
    lg: 'px-4 py-1.5 text-base',
  }
  
  return (
    <span className={`
      ${variants[variant]}
      ${sizes[size]}
      ${className}
      inline-flex items-center rounded-badge border font-medium
    `}>
      {children}
    </span>
  )
}

export default TaraBadge;